import {Fragment, useContext} from 'react';
import {node, string} from 'prop-types';
import styled from '@emotion/styled';
import Box from '../../shared/layouts/Box';
import Stack from '../../shared/layouts/Stack';
import Card from '../../shared/Card';
import Header from '../../shared/Header';
import Button from '../../shared/Button';
import CategoryHeader from './CategoryHeader';
import {CompareContext} from './ComparePage';
import {useTranslation} from "react-i18next";

const SplitBackground = styled(Box)(({ theme }) => ({
  background: `linear-gradient(90deg,
    ${theme?.colors?.white || 'white'} min(353px, 50%),
    ${theme?.colors?.primaryActive || 'azure'} 0
  )`,
}));

const CompareContainer = ({ section, title, icon, children }) => {
  const { showOnlyDiff, visibleSection, setVisibleSection, from } = useContext(
    CompareContext
  );
  const { t } = useTranslation();

  if (showOnlyDiff || visibleSection === section) {
    return (
      <Card p={{ mobile: 'm', desktop: 'xl' }}>
        <Header
          title={title}
          variant="section"
          icon={icon}
          button={
            <Button
              variant="action-outline"
              buttonSize="medium"
              onClick={() => {
                if (showOnlyDiff) {
                  setVisibleSection(section);
                } else {
                  setVisibleSection(null);
                }
              }}
            >
              {showOnlyDiff
                ? t('Alle gegevens tonen')
                : t('Afwijkende gegevens tonen')}
            </Button>
          }
        />
        <SplitBackground m={{ mobile: '0 -16px -16px', desktop: '0 -32px -32px' }}>
          <Box maxWidth={706} padding={{ mobile: '16px', desktop: '32px' }}>
            <Stack space="3xl">
              <CategoryHeader fontScale="l">
                <span>Jouw gegevens</span>
                <span>{from}</span>
              </CategoryHeader>
              {children}
            </Stack>
          </Box>
        </SplitBackground>
      </Card>
    );
  }

  return null;
};

CompareContainer.propTypes = {
  section: string,
  title: string,
  icon: node,
  children: node,
};

CompareContainer.defaultProps = {
  section: '',
  title: '',
  icon: <Fragment />,
  children: <Fragment />,
};

export default CompareContainer;
